/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import KidListContainer from "./KidListContainer";
import { useSelector, useDispatch } from "react-redux";
import DeviceContainer from "./DeviceContainer";
import Loader from "../../../../setup/Loader/LoaderIndicator";
import TodayWebActivity from "./DashboardGraph/TodayWebActivity";
import Activities from "./DashboardGraph/Activities";
import TodayAppActivities from "./DashboardGraph/TodayAppActivities";
import ScreenTime from "./DashboardGraph/ScreenTime";
import DashboardDailyLimit from "./DashboardDailyLimit";
import {
  setRulesDataApi,
  getSlots,
  setSlotData,
  setRulesData,
  dashboardData,
  updateDashboardData,
  getMessageCount,
  setMessageCountData,
} from "../../AxiosRtk/DashBoard";
import useLangTranslation from "../../../customHooks/languageProvider";
import DashboardSocialMedia from "./DashboardSocialMedia";
import DashboardKeyword from "./DashboardKeyword";
import DashboardIconFun from "./DashboardIconFun";
import SoSIem from "./SoSIem";
import {
  setShowInfo
} from "../../AxiosRtk/successMessage";
import { getAllApps, setAllAppData } from '../../AxiosRtk/DashBoard';
import useFirebase from "../../../../useFirebase";
import { getAccountDetails } from "../../AxiosRtk/Settings";

const Dashboard = () => {
  const [sosEmail, setSosEmail] = useState({ sos: false, phone: false });
  const [sosPhone, setSosPhone] = useState({ sos: false, phone: false });

  const dispatch = useDispatch();
  const history = useHistory();
  const [dashData, setDashboardData] = useState([]);


  const [input, setInput] = useState({
    phone_code: { value: "", error: "", errValue: "" },
    contact: { value: "", error: "", errValue: "" },
  });
  // console.log("input", input);

  const [displaySosItems, setDisplaySosAlertItems] = useState(false);
  const { kidList, dashboardLoader, selectedKidId, selectedDeviceData } = useSelector(
    ({ dashboard }) => dashboard
  );

  const { isAdditionalParent, user } = useSelector(({ auth }) => auth);

  const { getLangTranslation } = useLangTranslation();
  const { getCollectionData } = useFirebase();

  function setRulesApi() {
    setRulesDataApi({ kidId: selectedKidId, deviceId: selectedDeviceData?.ID })
      .then((res) => {
        dispatch(setRulesData(res?.data?.result));
      })
      .catch((err) => {
        console.log(
          "set rules data catch error ==>>",
          err?.response?.data?.message
        );
      });
  }

  function getSlotsApi() {
    const d = new Date();
    const weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    let day = weekday[d.getDay()];

    getSlots({ deviceId: selectedDeviceData?.ID, day })
      .then((res) => {
        dispatch(setSlotData(res?.data?.result));
      })
      .catch((err) => {
        console.log(
          "getting slots catch error ==>>",
          err?.response?.data?.message
        );
      });
  }

  function getDashboardData() {
    dashboardData()
      .then((res) => {
        setDashboardData(res?.data?.result);
        const displaySosAlert = res?.data?.result?.find(
          (item) => item?.receiveSosAlert === 1
        );
        setDisplaySosAlertItems(!displaySosAlert ? false : true);
      })
      .catch((err) => {
        console.log(
          "dashboard data catch error ==>>",
          err?.response?.data?.message
        );
      });
  }

  useEffect(() => {
    if (selectedKidId && selectedDeviceData) {
      setRulesApi();
      getSlotsApi();
      getCollectionData(selectedDeviceData?.ID);
      getAllApps({ kidId: selectedKidId, kidDeviceId: selectedDeviceData?.ID, pageOffset: 1, pageLimit: 500 })
        .then((res) => {
          dispatch(setAllAppData(res?.data?.result))
        })
        .catch((err) => {
          console.log("get all apps catch error ==>>", err?.response?.data?.message);
        })
    }
  }, [selectedKidId, selectedDeviceData]);

  useEffect(() => {
    if (selectedKidId) {
      getMessageCount({ kidId: selectedKidId, parentId: user?.ID })
        .then((res) => {
          dispatch(setMessageCountData(res?.data?.result));
        })
        .catch((err) => {
          console.log(
            "message count api catch error ==>>",
            err?.response?.data?.message
          );
        });
    }
  }, [selectedKidId]);

  useEffect(() => {
    getDashboardData();
  }, []);

  useEffect(() => {
    getAccountDetails()
      .then((res) => {
        const data = res?.data?.result[0];
        setInput({
          phone_code: { value: data?.phone_code, error: "" },
          contact: { value: data?.phone_no, error: "" },
        });
      })
      .catch((error) => {
        console.log(
          "get acc details catch error ==>>",
          error?.response?.data?.message
        );
      });
  }, []);

  function handleAddNewChild() {
    history.push("/add-new-child");
  }

  function emailVerifiedCross(item) {
    setSosEmail({
      ...sosEmail,
      email: true,
    });
    const payload = {
      isEmailVerified: 1
    };
    updateDashboardData(payload)
      .then(() => {
        getDashboardData();
      })
      .catch((err) => {
        console.log(
          "update dashboard data catch error ===>>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setSosEmail({
          ...sosEmail,
          email: false,
        });
      });
  }
  function phoneVerifiedCross(item) {
    setSosPhone({
      ...sosPhone,
      phone: true,
    });
    const payload = {
      isEmailVerified: 1
    };
    updateDashboardData(payload)
      .then(() => {
        getDashboardData();
      })
      .catch((err) => {
        console.log(
          "update dashboard data catch error ===>>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setSosPhone({
          ...sosPhone,
          phone: false,
        });
      });
  }

  function handleLocateMyFamily() {
    if (!selectedDeviceData) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please select device",
        })
      );
      return;
    } else {
      history.push("/locate-my-family");
    }
  }



  const isDevicesAvailable = kidList && selectedKidId
    ? kidList.find(kid => kid?.ID === selectedKidId)?.KidsDevices?.[0]?.Name
    : null;


  return (
    <>
      {dashboardLoader && !isDevicesAvailable && (
        <>
          <Loader height={20} width={100} />
          <div className="drawer-overlay" style={{ zIndex: "10" }}></div>
        </>
      )}
      <div className="card mb-6">
        <div className="card-body">
          {dashData?.length > 0 && !isAdditionalParent && (
            <>
              <div
                className={`row ${displaySosItems ? "justify-content-evenly" : ""
                  }`}
              >
                <>
                  {displaySosItems && (
                    <div
                      className="form-control col-md-6 my-2"
                      style={{ maxHeight: "200px", overflow: "auto" }}
                    >
                      {dashData?.map((item, index) => {
                        if (item?.receiveSosAlert === 1) {
                          return (
                            <SoSIem
                              item={item}
                              key={index}
                              getLangTranslation={getLangTranslation}
                              getDashboardData={getDashboardData}
                            />
                          );
                        } else {
                          return null;
                        }
                      })}
                    </div>
                  )}

                  <div className="row">
                    {dashData[0] && dashData[0]?.isEmailVerified === 1 && (
                      <div className="col-12 my-2 cursor-pointer">
                        <div
                          className="alert alert-warning alert-dismissible fade show d-flex align-items-center gap-3"
                          role="alert"
                        >
                          <i className="icon-message text-warning fs-5" />
                          {getLangTranslation(
                            "PARENT_DASHBOARD_ALERT_EMAIL_UNVERIFIED",
                            "Email unverified"
                          )}
                          {/* <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="alert"
                            aria-label="Close"
                            disabled={sosEmail?.email}
                            onClick={(e) => {
                              e.stopPropagation();
                              emailVerifiedCross(dashData[0]);
                            }}
                          ></button> */}
                        </div>
                      </div>
                    )}

                    {!input.contact.value && (
                      <div className="col-12 my-1 cursor-pointer">
                        <div
                          className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-2"
                          role="alert"
                        >
                          <i className="icon-info-octagon text-red-100 fs-5 c-pointer" />
                          {getLangTranslation(
                            "PARENT_DASHBOARD_YOUR_PHONE_MISSING_FROM_SOS",
                            "Please add your phone number for SOS alerts."
                          )}
                          {/* <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="alert"
                            aria-label="Close"
                            disabled={sosPhone?.phone}
                            onClick={(e) => {
                              e.stopPropagation();
                              phoneVerifiedCross(dashData[0]);
                            }}
                          ></button> */}
                        </div>
                      </div>
                    )}

                  </div>
                </>
              </div>
              <hr className="mt-0" />
            </>
          )}
          <div className="d-flex justify-content-between align-items-center mb-6">
            <h3 className="mb-0">
              {getLangTranslation("PARENT_DASHBOARD_MY_FAMILY", "My family")}
            </h3>
            {kidList?.length === 0 && !isAdditionalParent && (
              <button
                className="btn btn-primary text-uppercase custom-file-wrap d-inline-flex align-items-center gap-1"
                onClick={handleAddNewChild}
              >
                <i className="icon-plus fs-6" />
                {getLangTranslation(
                  "NEW_FAMILY_ADD_NEW_CHILD",
                  "Add new child"
                )}
              </button>
            )}
            {kidList?.length !== 0 && (
              <button
                className="btn btn-outline-primary text-uppercase fs-6 text-capitalize"
                onClick={() => handleLocateMyFamily()}
              >
                {getLangTranslation(
                  "PARENT_DASHBOARD_LOCATE_MY_FAMILY",
                  "Locate My Family"
                )}
              </button>
            )}
          </div>

          <KidListContainer
            kidListing={kidList}
            getLangTranslation={getLangTranslation}
          />

          {kidList?.length > 0 && isDevicesAvailable && (
            <>
              <div className="inline-list-wrap separator space-24 mt-4 flex-wrap flex-lg-nowrap">
                <DeviceContainer getLangTranslation={getLangTranslation} />
              </div>
            </>
          )}
          <hr />
          {kidList?.length > 0 && isDevicesAvailable && (

            <div className="inline-list-wrap separator space-24 my-4">
              <DashboardDailyLimit
                getLangTranslation={getLangTranslation}
              />
            </div>
          )}
          <hr />
          <DashboardIconFun />
        </div>
      </div>

      {kidList?.length > 0 && (
        <div className="row">
          <DashboardSocialMedia getLangTranslation={getLangTranslation} />
          <DashboardKeyword getLangTranslation={getLangTranslation} />
        </div>
      )}

      {kidList?.length === 1 ? (
        <div className="row">
          <ScreenTime getLangTranslation={getLangTranslation} />
          <Activities getLangTranslation={getLangTranslation} />
        </div>
      ) : (
        <>
          <div className="row">
            <TodayWebActivity getLangTranslation={getLangTranslation} />
            <Activities getLangTranslation={getLangTranslation} />
          </div>

          <div className="row">
            <TodayAppActivities getLangTranslation={getLangTranslation} />
            <ScreenTime getLangTranslation={getLangTranslation} />
          </div>
        </>
      )}
    </>
  );
};

export default Dashboard;
